/**
 * Banner — reveal the box + photo with a staggered fade/rise when they scroll
 * into view. Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initBanner = (section) => {
    const targets = Array.from(section.querySelectorAll('[data-banner-reveal]'));
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach((t) => t.classList.add('is-visible'));
      return;
    }

    targets.forEach((t, i) => t.style.setProperty('--banner-reveal-delay', `${i * 0.12}s`));

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    targets.forEach((t) => io.observe(t));
  };

  const boot = () => document.querySelectorAll('[data-banner]').forEach(initBanner);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-banner]');
    if (section) initBanner(section);
  });
})();
